// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchTextBox.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var Input = require('./Izenda.Input');
  var Icon = require('./Izenda.Icon');
  var classnames = require('classnames');
  var localizer = require('share/localization/Izenda.Localizer');
  const { omit, debounce, noop } = require('lodash/fp');
  var SearchTextBox = React.createClass({
    getInitialState: function() {
      return {
        searchValue: this.props.value
      };
    },
    componentWillMount: function() {
      this.debounceSearch =
        this.props.clickable && !this.props.debounceOnChange ? this.props.onChange : debounce(350, this.props.onChange);
    },
    componentWillReceiveProps: function(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({
          searchValue: nextProps.value
        });
      }
    },
    render: function() {
      var props = this.props;
      var clazz = classnames('izenda-SearchTextBox', props.className);
      var placeHolder = props.placeHolder || localizer.getText('ROLE_SETUP_USERS_LABEL_SEARCH');
      var clickable = props.clickable || false;
      var searchValue = this.state.searchValue;

      var onClick = props.onClick || noop();
      var rest = omit(
        ['className', 'type', 'placeholder', 'clickable', 'onClick', 'value', 'onChange', 'debounceOnChange'],
        props
      );

      var iconClazz = classnames('icon-search', {
        'izenda-SearchTextBox-Button': !clickable,
        'izenda-SearchTextBox-Button_clickable': clickable
      });

      return (
        <div className={clazz}>
          <Input
            type='text'
            className='izenda-SearchTextBox-TextBox'
            placeholder={placeHolder}
            value={searchValue}
            onChange={this.onSearchChange}
            {...rest}
          />

          <Icon className={iconClazz} onClick={onClick} />
        </div>
      );
    },
    onSearchChange: function(e) {
      (!this.props.clickable || this.props.debounceOnChange) && e.persist();
      this.debounceSearch(e);
      this.setState({
        searchValue: e.target.value
      });
    }
  });
  module.exports = SearchTextBox;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.SearchTextBox.jsx